export default "__VITE_ASSET__C1MyrKqN__"